import { render, staticRenderFns } from "./DynamicForm.vue?vue&type=template&id=34900a62&"
import script from "./DynamicForm.vue?vue&type=script&lang=js&"
export * from "./DynamicForm.vue?vue&type=script&lang=js&"
import style0 from "./DynamicForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VForm,VLayout})
